import api from "../axios/inventory"

export const getWarehouseStats = async () => {
  const res = await api.get("/inventory/warehouse/devices/stats/")
  return res.data
}

export const getTenantDevicesStats = async (tenant) => {
  if (!tenant) throw new Error("tenant is required")
  const res = await api.get(`/devices/${tenant}/devices/stats/`)
  return res.data
}


export const getTenantDevices = async (tenant, paramsOrUrl = {}) => {
  if (!tenant) throw new Error("tenant is required")

  if (typeof paramsOrUrl === "string" && paramsOrUrl.startsWith("http")) {
    const res = await api.get(paramsOrUrl)
    return res.data
  }

  if (typeof paramsOrUrl === "object" && paramsOrUrl !== null) {
    const pageVal = paramsOrUrl.page

    if (typeof pageVal === "string" && (pageVal.startsWith("http") || pageVal.startsWith("/"))) {
      const res = await api.get(pageVal)
      return res.data
    }
  }

  const params = {
    page: paramsOrUrl.page ?? 1,
  }

  if (paramsOrUrl.status) params.status = paramsOrUrl.status
  if (paramsOrUrl.location_id !== undefined && paramsOrUrl.location_id !== null) params.location_id = paramsOrUrl.location_id
  if (paramsOrUrl.search) params.search = paramsOrUrl.search

  const res = await api.get(`/devices/${tenant}/devices/`, { params })
  return res.data
}

export const getActiveTenantDevices = async (tenant, { locationId = null, page = 1, search = "" } = {}) => {
  const params = { status: "assigned", page }
  if (locationId !== null && locationId !== undefined) params.location_id = locationId
  if (search) params.search = search
  return getTenantDevices(tenant, params)
}

export const getDeactivatedTenantDevices = async (tenant, { locationId = null, page = 1, search = "" } = {}) => {
  const params = { status: "unlinked", page }
  if (locationId !== null && locationId !== undefined) params.location_id = locationId
  if (search) params.search = search
  return getTenantDevices(tenant, params)
}

export const searchDevicesByImei = async (tenantOrUrl, q, pageOrUrl = 1) => {
  const query = q !== undefined && q !== null ? String(q).trim() : ""
  if (!query) {
    return { results: [], meta: null }
  }

  try {
    const params = { q: query }

    if (typeof pageOrUrl === "number") {
      params.page = pageOrUrl
    }

    if (typeof tenantOrUrl === "string" && tenantOrUrl.startsWith("http")) {
      const res = await api.get(tenantOrUrl, { params })
      return res.data ?? res
    }

    if (typeof tenantOrUrl === "string" && tenantOrUrl.startsWith("/")) {
      if (typeof pageOrUrl === "string" && (pageOrUrl.startsWith("/") || pageOrUrl.startsWith("http"))) {
        const res = await api.get(pageOrUrl)
        return res.data ?? res
      }

      const res = await api.get(tenantOrUrl, { params })
      return res.data ?? res
    }

    if (typeof pageOrUrl === "string" && (pageOrUrl.startsWith("/") || pageOrUrl.startsWith("http"))) {
      const res = await api.get(pageOrUrl)
      return res.data ?? res
    }

    const res = await api.get("/inventory/warehouse/devices/", { params })
    return res.data ?? res
  } catch (err) {
    console.error("searchDevicesByImei error:", err)
    return { results: [], meta: null }
  }
}

export const createWarehouseTicket = async ({ device_id, issue_description }) => {
  if (!device_id) throw new Error("device_id is required")
  if (!issue_description) throw new Error("issue_description is required")

  const payload = {
    device_id,
    issue_description,
  }

  const res = await api.post("/devices/warehouse-ticket/", payload)
  return res.data
}


export const getAvailableTenantDevices = async (tenant, { locationId = null, page = 1, search = "" } = {}) => {
  const params = { status: "available", page }
  if (locationId !== null && locationId !== undefined) params.location_id = locationId
  if (search) params.search = search
  return getTenantDevices(tenant, params)
}

export default {
  getWarehouseStats,
  getTenantDevicesStats,
  getTenantDevices,
  getActiveTenantDevices,
  getDeactivatedTenantDevices,
  getAvailableTenantDevices, // <--- new
  searchDevicesByImei,
  createWarehouseTicket,
}
